export default __webpack_public_path__ + "static/media/plus_black.75127cf8.svg";